"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Loader, CircleCheck } from "lucide-react";
export default function ZarezerwujSwojeMiejsce() {
  return <section id="zarezerwuj-swoje-miejsce" className="dark bg-background text-foreground relative overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none flex items-center justify-center">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/new_wave_camp_watermark.png" alt="" className="w-[150%] max-w-none h-auto object-cover mix-blend-overlay" aria-hidden="true" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-12 space-y-4">
          <h2 className="text-lg md:text-2xl font-bold uppercase tracking-tight text-foreground">
            Zarezerwuj Swoje Miejsce
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mt-2">
            Dołącz do elitarnego obozu sportowego na Koh Samui. Wypełnij poniższy formularz, aby rozpocząć swoją przygodę.
          </p>
        </div>

        <FormProvider formId="reservation_form_start" sectionName="zarezerwuj-swoje-miejsce" defaultValues={{
        full_name: "",
        email: "",
        phone: "",
        data_urodzenia: "",
        message: ""
      }} validationRules={{
        full_name: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        phone: {
          required: true,
          minLength: 9
        },
        data_urodzenia: {
          required: true,
          message: "Data urodzenia jest wymagana"
        }
      }} submitText="ZAREZERWUJ SWOJE MIEJSCE" successMessage="Dziękujemy za rezerwację! Skontaktujemy się z Tobą wkrótce w celu potwierdzenia szczegółów.">
          <Card className="bg-card/60 backdrop-blur-xl border-border/50 shadow-2xl overflow-hidden">
            <ReservationFormInner />
          </Card>
        </FormProvider>
      </div>
    </section>;
}
function ReservationFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-12 text-center space-y-6 flex flex-col items-center justify-center min-h-[400px]">
        <div className="size-20 bg-primary/20 rounded-full flex items-center justify-center mb-4">
          <CircleCheck className="size-10 text-primary" />
        </div>
        <h3 className="text-3xl font-bold text-foreground">Rezerwacja Przyjęta!</h3>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          {successMessage}
        </p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="flex flex-col">
      <div className="flex justify-center p-4 sm:p-8 lg:p-12">
        <div className="space-y-8 w-full max-w-2xl">
          <div>
            <h3 className="text-2xl font-bold uppercase tracking-tight text-foreground mb-2 flex items-center gap-2">
              <span className="bg-primary/20 text-primary size-8 rounded-full flex items-center justify-center text-sm">1</span>
              Twoje Dane
            </h3>
            <p className="text-sm text-muted-foreground">
              Wprowadź swoje dane kontaktowe, abyśmy mogli przygotować Twoją rezerwację.
            </p>
          </div>

          <div className="space-y-5">
            <FormField control={control} name="full_name" rules={{
            required: "Imię i nazwisko jest wymagane"
          }} render={({
            field
          }) => <FormItem>
                  <FormLabel className="text-foreground/90">Imię i Nazwisko</FormLabel>
                  <FormControl>
                    <Input placeholder="Jan Kowalski" className="bg-background/50 border-border/50 focus-visible:ring-primary h-12 text-base" {...field} />
                  </FormControl>
                  <FormDescription className="text-xs">Wpisz imię i nazwisko zgodnie z dokumentem tożsamości.</FormDescription>
                  <FormMessage />
                </FormItem>} />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <FormField control={control} name="email" rules={{
              required: "Adres email jest wymagany",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Nieprawidłowy adres email"
              }
            }} render={({
              field
            }) => <FormItem>
                    <FormLabel className="text-foreground/90">Adres Email</FormLabel>
                    <FormControl>
                      <Input type="email" placeholder="jan@example.com" className="bg-background/50 border-border/50 focus-visible:ring-primary h-12 text-base" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>} />

              <FormField control={control} name="phone" rules={{
              required: "Numer telefonu jest wymagany"
            }} render={({
              field
            }) => <FormItem>
                    <FormLabel className="text-foreground/90">Numer Telefonu</FormLabel>
                    <FormControl>
                      <Input type="tel" placeholder="+48 123 456 789" className="bg-background/50 border-border/50 focus-visible:ring-primary h-12 text-base" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>} />
            </div>

            <FormField control={control} name="data_urodzenia" rules={{
            required: "Data urodzenia jest wymagana"
          }} render={({
            field
          }) => <FormItem>
                  <FormLabel className="text-foreground/90">Data urodzenia</FormLabel>
                  <FormControl>
                    <Input type="date" className="bg-background/50 border-border/50 focus-visible:ring-primary h-12 text-base" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>} />

            <FormField control={control} name="message" render={({
            field
          }) => <FormItem>
                  <FormLabel className="text-foreground/90">Dodatkowa Wiadomość (Opcjonalnie)</FormLabel>
                  <FormControl>
                    <Textarea placeholder="Masz specjalne życzenia lub pytania? Napisz je tutaj..." className="bg-background/50 border-border/50 focus-visible:ring-primary min-h-[100px] resize-y text-base" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>} />
          </div>
        </div>
      </div>

      {}
      <div className="p-8 lg:p-12 pt-0 lg:pt-0">
        {submitError && <div className="mb-6 p-4 bg-destructive/10 border border-destructive/20 rounded-lg text-center">
            <p className="text-destructive font-medium">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full h-16 text-base md:text-lg font-bold uppercase tracking-wider bg-gradient-to-r from-secondary to-chart-3 hover:from-secondary/90 hover:to-chart-3/90 text-white border-0 shadow-[0_0_30px_-5px_rgba(234,88,12,0.4)] hover:shadow-[0_0_40px_-5px_rgba(234,88,12,0.6)] transition-all duration-300 rounded-xl">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-3 size-6" />
              Przetwarzanie...
            </> : "ZAREZERWUJ SWOJE MIEJSCE"}
        </Button>
      </div>
    </Form>;
}